import React, { Component } from 'react'
import CardForm from 'Utils/Cards/CardForm';
import LoadMask from 'Utils/LoadMask/LoadMask';
import Form from './PackingForm';
import { PackingUpdateForm } from './PackingForm';

export default class CreatePacking extends Component {
  state = {
      editar: false,
  };
  componentDidMount(){
      if(this.props.match.params.id){
          this.props.leer(this.props.match.params.id);
          this.setState({
                editar: true,
            });
      }
  }
  actualizar = (data) =>{
        this.props.editar(this.props.match.params.id, data)
    };
    getPermissions = () => {
        const { getMe } = this.props;
        getMe();
    }
  render() {
    const { crear } = this.props;
    const { updateData, loader } = this.props;
    return (
      <div className="mb-4 col-12">
        <CardForm
          icon="configuraciones_activo.png"
          titulo="ADMINISTRACIÓN"
          subtitulo="EMPAQUES"
          subtituloForm = {this.state.editar ? "Editar" : "Nuevo"}
          col="11">
          <LoadMask loading={loader} blur>
            {
              this.state.editar ?
                <PackingUpdateForm
                  onSubmit={this.actualizar}
                  updateData={updateData}
                  permisos={this.getPermissions}
                  isEdit={this.state.editar}/>
                  
                :
                <Form onSubmit={crear}/>
            }
          </LoadMask>
        </CardForm>
      </div>
    )
  }
}
